import { render } from "./DropzoneFileUpload.vue?vue&type=template&id=667aadbe"
import script from "./DropzoneFileUpload.vue?vue&type=script&lang=js"
export * from "./DropzoneFileUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__